/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dealdeclined2Inputs */

const en_coinvestments_dealdeclined2 = /** @type {(inputs: Coinvestments_Dealdeclined2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opportunity Declined`)
};

/**
* | output |
* | --- |
* | "Opportunity Declined" |
*
* @param {Coinvestments_Dealdeclined2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dealdeclined2 = /** @type {((inputs?: Coinvestments_Dealdeclined2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dealdeclined2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dealdeclined2(inputs)
});
export { coinvestments_dealdeclined2 as "coInvestments_dealDeclined" }